import React, { useRef } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import CtaButton from '../../ctaButton/ctaButton';
import styles from './signIn.module.scss';
import useDetectOutsideClick from '../../../hooks/useDetectOutsideClick';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';

export default function SignIn({ isLoggedIn = false, signInData = {} }) {
  const dropdownRef = useRef(null);
  const subDropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const [isSubActive, setIsSubActive] = useDetectOutsideClick(
    subDropdownRef,
    false
  );
  const navActiveClass = isActive ? styles.active : styles.inActive;
  const buttonActiveClass = isSubActive ? styles.open : '';
  const subNavActiveClass = isSubActive ? styles.activeSub : styles.inActiveSub;

  const signInHeapTrack = async (heapEventKey) => {
    try {
      return await trackHeapEvent(
        { Name: 'Global Nav Sign In', CTA: heapEventKey.replace(' ', '_') },
        'CMS_Unification'
      );
    } catch (err) {
      return Promise.reject(err); // it's unclear what the app expects on a failure
    }
  };

  const onClick = (heapKey) => {
    signInHeapTrack(heapKey);
    if (signInData.link) {
      window.location.assign(signInData.link);
    } else {
      setTimeout(() => {
        setIsActive(!isActive);
      }, 1);
    }
  };
  const onSubClick = (heapKey) => {
    setTimeout(() => {
      setIsSubActive(!isSubActive);
      signInHeapTrack(heapKey);
    }, 1);
  };

  return isLoggedIn ? (
    <div className={styles.cta}>
      <CtaButton
        data-testid="sign-out"
        label="Sign Out"
        fullWidth={false}
        variant="secondary"
        color="red"
        className={`${styles.signInButton}`}
        type="button"
        href="/account/logout.action"
        onClick={() => onClick('Sign Out')}
      />
    </div>
  ) : (
    <>
      <div className={styles.cta}>
        {signInData?.title && (
          <CtaButton
            label={signInData.title}
            fullWidth={false}
            variant="secondary"
            type="button"
            color="red"
            onClick={() => onClick(signInData.title)}
            className={`${styles.signInButton}`}
          />
        )}
      </div>
      <nav ref={dropdownRef} className={`${styles.menus} ${navActiveClass}`}>
        <ul className={styles.navDropdownRedesign}>
          {signInData?.items &&
            signInData.items?.map((links, index) => {
              const key = `sign-${index}`;
              if (!links?.items) {
                return (
                  <li className={styles.navDropdownRedesignItem} key={key}>
                    {links?.label && (
                      <CtaButton
                        data-testid={links.label}
                        label={links.label}
                        color="blue"
                        className={`${styles.link}`}
                        fullWidth={false}
                        variant="secondary"
                        href={links.link}
                        onClick={() => onClick(links.label)}
                      />
                    )}
                  </li>
                );
              }
              if (links?.items) {
                return (
                  <li
                    key={key}
                    className={`${styles.navDropdownRedesignItem} ${styles.hasSub}`}
                  >
                    {links?.label && (
                      <CtaButton
                        data-testid={links.label}
                        color="blue"
                        label={links.label}
                        className={`${styles.link} ${buttonActiveClass}`}
                        fullWidth={false}
                        variant="secondary"
                        onClick={() => onSubClick(links.label)}
                      />
                    )}

                    <nav
                      ref={subDropdownRef}
                      className={`${styles.menuSub} ${subNavActiveClass}`}
                    >
                      <ul className={styles.navDropdownRedesignSub}>
                        {links.items.map((sublinks, i) => {
                          const signkey = `investor-${i}`;
                          return (
                            <li key={signkey}>
                              <Link
                                href={sublinks.link}
                                onClick={() => onSubClick(sublinks.label)}
                                data-testid={sublinks.label}
                              >
                                {sublinks.label}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </nav>
                  </li>
                );
              }
              return null;
            })}
        </ul>
      </nav>
    </>
  );
}

SignIn.propTypes = {
  isLoggedIn: PropTypes.bool,
  signInData: PropTypes.object,
};
